<template>
  <div class="m-1">
    <Input
      :label="$t('link')"
      :value="options.href"
      @enter="propChanged('href', $event)"
      @blur="propChanged('href', $event)"
    />
    <br />
    <span>{{ $t('width') }}</span>
    <SpacementInput :value="options.width" @change="propChanged('width', $event)" />
    <br />
    <label for="postsToShow">{{ $t('posts-to-show') }}</label>
    <b-form-input
      id="postsToShow"
      :value="options.postsToShow"
      @keypress.prevent
      type="number"
      min="1"
      max="10"
      @change="propChanged('postsToShow', $event)"
    ></b-form-input>
  </div>
</template>

<script>
import WidgetSideNavMixin from './Mixin.js'
import SpacementInput from '@/components/sidenav/shared/SpacementInput'

export default {
  name: 'FacebookCommentsSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.facebook-comments-side-nav' },
  components: { SpacementInput },
  mixins: [WidgetSideNavMixin],
}
</script>
